import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import InputNumberCommon from '../../../CommonV2/InputNumber';

/**
 * FieldInputNumber
 * @param {*} param0
 */
const FieldInputNumber = ({
  code,
  disabled,
  decimalScale,
  thousandSeparator,
  decimalSeparator,
  prefix,
  suffix,
  isAllowed,
  validate,
  existError,
  showError,
  handleBlur,
  param,
  placeholder,
}) => {
  const isAllowedLocal = values => {
    let isValuesAllowed = true;
    if (param && (param.min != null || param.max != null)) {
      const { floatValue } = values;

      if (param.min != null) {
        isValuesAllowed = isValuesAllowed && floatValue >= param.min;
      }

      if (param.max != null) {
        isValuesAllowed = isValuesAllowed && floatValue <= param.max;
      }
    }

    if (isAllowed) {
      isValuesAllowed &= isAllowed(values);
    }

    return isValuesAllowed;
  };

  return (
    <Field
      component={InputNumberCommon}
      disabled={disabled}
      name={code}
      decimalScale={decimalScale}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      prefix={prefix}
      suffix={suffix}
      isAllowed={isAllowedLocal}
      validate={validate}
      existError={existError}
      showError={showError}
      eventEmitter={v => handleBlur(v)}
      placeholder={placeholder}
    />
  );
};

FieldInputNumber.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  validate: PropTypes.func.isRequired,
  decimalScale: PropTypes.number,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  isAllowed: PropTypes.func,
  handleBlur: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  param: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
  }),
  placeholder: PropTypes.string,
};
FieldInputNumber.defaultProps = {
  decimalScale: 2,
  thousandSeparator: undefined,
  decimalSeparator: undefined,
  disabled: false,
  prefix: '',
  suffix: '',
  isAllowed: undefined,
  param: {},
  placeholder: undefined,
};

export default connect(FieldInputNumber);
